import { render, staticRenderFns } from "./sfc-modal.vue?vue&type=template&id=ff606c02&scoped=true&lang=pug&"
import script from "./sfc-modal.vue?vue&type=script&lang=js&"
export * from "./sfc-modal.vue?vue&type=script&lang=js&"
import style0 from "./sfc-modal.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./sfc-modal.vue?vue&type=style&index=1&id=ff606c02&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff606c02",
  null
  
)

export default component.exports